import { CommonConfirmationDialog } from 'components/common/dialogs/confirmation';
import { SharedListDeleteConfirmation } from 'components/common/pitch-lists/shared-list-delete-warning';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { IPitchList } from 'lib_ts/interfaces/pitches';
import { useNavigate } from 'react-router-dom';
import { paths } from 'routes/paths';
import useListLibraryStore from 'stores/use-list-library-store';

interface IProps {
  lists: IPitchList[];
}

export const DeleteFolderDialog = (props: IProps) => {
  const navigate = useNavigate();
  const activeList = useListLibraryStore((s) => s.activeList);

  return (
    <CommonConfirmationDialog
      identifier="DeleteFolderDialog"
      maxWidth={RADIX.DIALOG.WIDTH.MD}
      title="common.delete"
      content={<SharedListDeleteConfirmation lists={props.lists} />}
      action={{
        label: 'common.delete',
        color: RADIX.COLOR.DANGER,
        onClick: async () => {
          /** used to trigger auto-reset to pitch design section upon success */
          const deleteIDs = props.lists.map((l) => l._id);

          const success = await useListLibraryStore
            .getState()
            .deleteLists(deleteIDs);

          if (!success) {
            return;
          }

          /** change to different section before active list is set to null */
          if (activeList && deleteIDs.includes(activeList._id)) {
            navigate(paths.home);
          }
        },
      }}
    />
  );
};
